<template>  
  <debug-list />  
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import DebugList from '@/components/admin/debug/DebugList.vue'
import { Watch} from 'vue-property-decorator'
import { SecurityItemsKeys } from '@/enum/SecurityItems';


@Component({
  name: 'Debug',
  components: {DebugList}
})
export default class Debug extends Vue {  
  beforeRouteEnter(to:any,from:any,next:any) {        
     next((vm:Debug) => {              
       next(vm.$store.myGetters.userSecurity[SecurityItemsKeys.DEBUG_LOG].enable?'':'/login')
     })
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  
</style>
